export default __webpack_public_path__ + "static/understanding_the_economy-cf7e7fe2a745ad5e4797c8dab382881a.png";